import React from 'react';
import ReactDOM from 'react-dom';
import Warn from './Warn';
import Copy from 'copy-to-clipboard';
import Fade from './Fade';
import FormResourceUtil from './FormResourceUtil';
import CommandResolver from './CommandResolver';
import CommandHelper from '../remote/CommandHelper';
import ServiceHelper from '../remote/ServiceHelper';
const ReactDataGrid = require('react-data-grid');

export default class RemotePasteDialog extends React.Component
{
    static typetocn = {0:"字符串",1:"长整数",2:"小数",3:"日期",4:"时间",5:"是否"};
    static MODE_IN = "In";
    static MODE_OUT = "Out";
    static TYPE_KEYVALUE = "KeyValue";
    static TYPE_TEXT = "Text";
    static TYPE_DATAGRID = "DataGrid";
    
    static MODE_IN_0_PROMPT = "右键粘贴剪贴板数据到下面文本框";
    static MODE_IN_1_PROMPT = "点击粘贴数据按钮,将剪贴板数据粘贴到文本框,最后点击确定";
    static MODE_IN_2_PROMPT = "点击粘贴数据按钮,将剪贴板数据粘贴到文本框,最后点击确定";
    
    static MODE_OUT_0_PROMPT = "在下面文本框右键复制数据";
    static MODE_OUT_1_PROMPT = "在下边表格中右键复制数据";
    static MODE_OUT_2_PROMPT = "在下边表格中右键复制数据";
    constructor(props)
    {
        super(props);
        this.state={
			mode:this.props.remotearg.mode,
            type:this.props.remotearg.type,
            keyValueGridRows:[],
            gridColumns:[],
            gridDataProvider:[],
            selectedIndexes:[0],
            keyValueColumns:[{key:'key',name: "属性名称",width: 130,resizable: true},
            {key:'value',name: "属性值",width: 130,resizable: true}],
            title:this.props.remotearg.title
        };
        
        

        if(this.state.mode == RemotePasteDialog.MODE_IN && this.props.type == RemotePasteDialog.TYPE_KEYVALUE)
        {
            if(this.props.remotearg && this.props.remotearg.fields && this.props.remotearg.fields.length>0)
            {
                var fixedData = [];
                for(let i = 0;i<this.props.remotearg.fields.length;i++)
                {
                    let field = this.props.remotearg.fields[i];
                    fixedData.push({key:field.label==""?RemotePasteDialog.typetocn[String(field.fieldType)]:field.label,value:"",serverfield:field.dataField}); 
                }
                this.state.keyValueGridRows = fixedData;
            }
        }
        else if(this.state.mode == RemotePasteDialog.MODE_IN && this.state.type == RemotePasteDialog.TYPE_DATAGRID)
        {
            
            if(this.props.remotearg && this.props.remotearg.fields && this.props.remotearg.fields.length>0)
            {
                var headers = [];
                for(let i = 0;i<this.props.remotearg.fields.length;i++)
                {
                    let field = this.props.remotearg.fields[i];
                    var gc  = {};gc.type = field.fieldType;gc.numOfDecimals = field.numOfDecimals;gc.name = field.label;gc.key = field.dataField;
                    gc.resizable = true;
                    headers.push(gc);
                }
                this.state.gridColumns = headers;
            }
            else
            {
                //this.state.gridColumns = [{key:'key',name: "右键选择粘贴",width: 130,resizable: true}];
            }
        }
        else if(this.props.remotearg.mode == RemotePasteDialog.MODE_OUT)
        {
            if(this.props.remotearg.type == RemotePasteDialog.TYPE_TEXT)
            {
                this.state.mode0Text = remotearg.data;
            }
            else if(this.props.remotearg.type == RemotePasteDialog.TYPE_KEYVALUE)
            {
                
                var datas = [];
                if(this.props.remotearg.fields && this.props.remotearg.fields.length>1)
                {
                    for(key in remotearg.data)
                    {
                        data = {};var keyLabel= "";
                        for(let i = 0;i<this.props.remotearg.fields.length;i++)
                        {
                            let field = this.props.remotearg.fields[i];
                            if(field.dataField == key)
                                keyLabel = ((field.label==""||field.label==null)?key:field.label);
                        }
                        data["key"] = keyLabel;
                        data["value"] = this.props.remotearg.data[key];
                        datas.push(data);
                    }
                    this.state.keyValueGridRows = datas;
                }
                else
                {
                    for(var key in this.props.remotearg.data)
                    {
                        var data = {};data["key"] = key;data["value"] = this.props.remotearg.data[key];datas.push(data);
                    }
                    this.state.keyValueGridRows = datas;
                }
            }
            else if(this.props.remotearg.type == RemotePasteDialog.TYPE_DATAGRID)
            {
                if(this.props.remotearg.fields && this.props.remotearg.fields.length>0)
                {
                    var headers = [];
                    for(let i = 0;i<this.props.remotearg.fields.length;i++)
                    {
                        let field = this.props.remotearg.fields[i];
                        gc = {};gc.name = field.label;gc.key = field.dataField;gc.type = field.fieldType;gc.numOfDecimals = field.numOfDecimals;
                        gc.resizable = true;headers.push(gc);
                    }
                    this.state.gridColumns = headers;
                    this.state.gridDataProvider = this.props.remotearg.data;
                }
                else
                {
                    if(typeof(this.props.remotearg.data) == "Array" && this.props.remotearg.data.length>0)
                    {
                        var first = this.props.remotearg.data[0];
                        for(key in first)
                        {
                            gc = {};gc.name = key;gc.key = key;
                            gc.resizable = true;headers.push(gc);
                        }
                        this.state.gridColumns = headers;
                        this.state.gridDataProvider = this.props.remotearg.data;
                    }
                    else
                    {
                        Warn.show({text:"服务端未能传回数据"});
                    }
                }
            }
        }
    }

    getKeyValueGridRowAt(index)
    {
        if (index < 0 || index > this.getKeyValueGridSize()) {
            return undefined;
        }

        return this.state.keyValueGridRows[index];

    }

    getKeyValueGridSize()
    {
        return this.state.keyValueGridRows.length;
    }

    getGridRowAt = (index) =>
    {
        if (index < 0 || index > this.getGridSize()) {
            return undefined;
        }

        return this.state.gridDataProvider[index];

    }

    getGridSize = () =>
    {
        return this.state.gridDataProvider.length;
    }

    close()
    {	
		ReactDOM.unmountComponentAtNode(document.getElementById('remotePasteDialogModal'));
        $(this.remotePasteDialogContainer).remove();
        $('#remotePasteDialogModal').hide();
    }

    closePaste(){
        $(this.pasteHelperContainer).remove();
    }

    componentDidMount()
    {
        $(this.remotePasteDialogContainer).draggable({
          handle: ".modal-header" // 只能点击头部拖动
        }); //为模态对话框添加拖拽

        $(this.pasteHelperContainer).draggable({handle:".modal-header"});

        /*let contextMenuItems;

        var remotearg = this.props.remotearg;
        if(remotearg)
        {
            
            if(remotearg.mode == RemotePasteDialog.MODE_IN)
            {
                contextMenuItems = [
                    {label:'粘贴',icon:'',action:this.contextMenuPasteHandler.bind(this)}
                ];
            }
            else
            {
                contextMenuItems = [
                    {label:'复制',icon:'',action:this.contextMenuPasteHandler.bind(this)}
                ];
            }
            
        }

        if(this.grid)
            $(this.grid).find(".react-grid-Canvas")
                .contextPopup({items:contextMenuItems}).css({'overflow-y':'auto','overflow-x':'scroll'});
        else if(this.keyValueGrid)
            $(this.keyValueGrid).find(".react-grid-Canvas")
                .contextPopup({items:contextMenuItems}).css({'overflow-y':'auto','overflow-x':'scroll'});*/

        
        /*if(this.grid)
            $(this.grid).contextPopup({items:contextMenuItems});
        else if(this.keyValueGrid)
            $(this.keyValueGrid).contextPopup({items:contextMenuItems});*/
    }

    copyPasteClick()
    {
        if(this.state.mode == RemotePasteDialog.MODE_IN)
        {
            $(this.pasteHelperContainer).show();
        }
        else if(this.state.mode == RemotePasteDialog.MODE_OUT)
        {
            if(this.state.type == RemotePasteDialog.TYPE_KEYVALUE)
            {
                this.grid1_copyHandler();
            }
            else
            {
                this.grid_copyHandler();
            }
        }
    }

    contextMenuPasteHandler()
    {
        $(this.pasteHelperContainer).show();
    }

    btnPasteRequire()
    {
        if(this.state.type == RemotePasteDialog.TYPE_KEYVALUE)
        {
            this.paste1Handler($(this.pasteTextContainer).val());
        }
        else if(this.state.type == RemotePasteDialog.TYPE_DATAGRID)
        {
            this.pasteHandler($(this.pasteTextContainer).val());
        }
        $(this.pasteHelperContainer).hide();
    }

    doPaste(text,colNum = 0)
    {
        var remotearg = this.props.remotearg;
        if(!remotearg)
            return null;
       
        if(!text)
        {
            Warn.show({text:"未在剪贴板中找到文本数据"});
            return null;
        }
        //try
        //{
            var rows = text.split("\n");var colnum = -1;var ac = [];var obj;var i = 0;var k = 0;var headers = []; var gc;
            for(let i = 0;i<rows.length;i++)
            {
                let row = rows[i];
                if(!row)
                    continue;
                var columns = row.split(/[\t]/g);
                if(colnum == -1)
                    colnum = columns.length;
                obj = {};
                for(let k = 0;k<columns.length;k++)
                {
                    let coldata = columns[k]
                    if(i==0)
                    {
                        gc = {};
                        if(remotearg.isDataWithHeader == true)
                        {
                            gc.name = coldata;gc.key = coldata;gc.resizable = true;
                        }
                        else
                        {
                            obj[k+''] = coldata;gc.key = k+'';gc.resizable = true;
                        }
                        headers.push(gc);
                    }
                    else
                    {
                        //第一行与第二行所标识的列数不一样 以第一行为准 后面的将忽略
                        if(k>headers.length-1)
                        {
                            gc = {};gc.resizable = true;gc.name = "";gc.key=k+'';headers.push(gc);
                            //break;
                        }
                        let header = headers[k];
                        var key = header.key;
                        obj[key] = coldata;
                        if(!header.width){header.width = (coldata+"").visualLength()+25+"px";}
                        else
                        {
                            let coldataLength = (coldata+"").visualLength();
                            if(coldataLength>header.width)header.width = coldataLength+25+"px";
                        }
                        
                    }
                    if(colNum!=0 && k==colNum)
                        break;
                }
                
                if(remotearg.isDataWithHeader == true)
                {
                    if(i!=0)
                        ac.push(obj);
                }
                else
                {
                    ac.push(obj);
                }
            }
           
            var result = {columns:headers,datas:ac};
            return result;
            
        //}catch(e)
        //{
        //    Warn.show({text:"无法解析复制的文本"});
        //}
        return null;
    }
    
    pasteHandler(text)
    {
        var remotearg = this.props.remotearg;
        if(remotearg)
        {
            if(remotearg.fields && remotearg.fields.length>0)
            {
                if(!text)
                {
                    Warn.show({text:"未在剪贴板中找到文本数据"});
                    return;
                }
                try
                {
                    var rows = text.split("\n");var datas = [];
                    for(let i = 0;i<row.length;i++)
                    {
                        var row = rows[i];
                        var columns = row.split(/[\t]+/g);var data={};
                        for(let k=0;k<columns.length;k++)
                        {
                            if(k>this.state.gridColumns.length-1)
                                break;
                            var dataField = gridColumns[k].key;
                            data[dataField] = columns[k];
                        }
                        
                        if(columns.length<this.state.gridColumns.length)
                        {
                            for(let l = columns.length;l<this.state.gridColumns.length;l++)
                            {
                                data[gridColumns[l].key] = ""; 
                            }
                        }
                        datas.push(data);
                    }
                    this.setState({gridDataProvider:datas});
                    
                }catch(e)
                {
                    
                }
            }
            else
            {
                var dataprovider = this.doPaste(text);
                if(dataprovider)
                {
                    this.setState({gridColumns:dataprovider.columns,gridDataProvider:dataprovider.datas});
                }
            }
        }
    }
    
    //有fields
    paste1Handler(text)
    {
        if(!text)
        {
            Warn.show({text:"未在剪贴板中找到文本数据"});
            return;
        }
        var remotearg = this.props.remotearg;
        if(!remotearg)
            return;
        if(remotearg.fields && remotearg.fields.length>0)
        {
            try
            {
                var rows = text.split("\n");
                for(let i=0;i<this.state.keyValueGridRows.length;i++)
                {
                    var item = keyValueGridRows[i];
                    if(i>=rows.length)
                        break;
                    var row = rows[i];
                    if(!row)
                        continue;
                    var columns = row.split(/[\t]+/g);
                    var value = columns[columns.length-1];
                    item.value = value;
                }
                this.setState({keyValueGridRows:this.state.keyValueGridRows.slice()});
                //this.forceUpdate();
                
            }catch(e)
            {
                Warn.show({text:"粘贴的数据有不可识别的格式"});
            }
        }
        else
        {
            try
            {
                var newGrid1Data = [];
                var rows = text.split("\n");
                for(let i=0;i<rows.length;i++)
                {
                    var row = rows[i];
                    if(!row)
                        continue;
                    var columns = row.split(/[\t]+/g);
                    if(columns.length==0)
                        break;
                    if(columns.length==1)
                        columns.unshift(i);
                    var item = {};
                    for(let k = 0;k<2;k++)
                    {
                        var key = (k==0?"key":"value");
                        item[key] = columns[k]
                    }
                    newGrid1Data.push(item);
                }
                this.setState({keyValueGridRows:newGrid1Data});
                
            }catch(e)
            {
                Warn.show({text:"粘贴的数据有不可识别的格式"});
            }
        }
    }

    handleGridRowsUpdated2 = ({ fromRow, toRow, updated }) => {
        let rows = this.state.keyValueGridRows.slice();
    
        for (let i = fromRow; i <= toRow; i++) {
          let rowToUpdate = rows[i];
          let updatedRow = $.extend(rowToUpdate,updated);
          rows[i] = updatedRow;
        }
        this.setState({ keyValueGridRows:rows});
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        let rows = this.state.gridDataProvider.slice();
    
        for (let i = fromRow; i <= toRow; i++) {
          let rowToUpdate = rows[i];
          let updatedRow = $.extend(rowToUpdate,updated);
          rows[i] = updatedRow;
        }
        this.setState({ gridDataProvider:rows});
    };

    btnclear0_clickHandler(event)
    {
        $(this.textModeInput).val("");
    }
    
    btnclear1_clickHandler(event)
    {
       this.setState({keyValueGridRows:[]});
    }
    
    btnclear2_clickHandler(event)
    {
        this.setState({gridDataProvider:[],gridColumns:[]});
    }


    getTaskGroup(task, fm)
    {
        if(!task || !fm || !fm.formDataSources)
            return null;
        var group;
        if(task.group)
            group = fm.formDataSources.groups[task.group];
        
        if(!group)
            group = fm.formDataSources.getFirstGroup();
        
        return group;
        
    }
    
    getInData(remotearg)
    {
        if(this.state.type == RemotePasteDialog.TYPE_KEYVALUE)
        {
            var _arg = {};
            if(this.props.remotearg && this.props.remotearg.fields && this.props.remotearg.fields.length>0)
            {
                for(let i = 0;i<this.state.keyValueGridRows.length;i++)
                {
                    let item = this.state.keyValueGridRows[i];
                    _arg[item.serverfield] = item.value;
                }
            }
            else
            {
                var ac = this.state.keyValueGridRows;
                var column0 = this.state.keyValueColumns[0];
                var column1 = this.state.keyValueColumns[1];
                var key1 = column0.key;
                var key2 = column1.key;
                for(let i = 0;i<ac.length;i++)
                {
                    let item = ac[i];
                    _arg[item[key1]] = item[key2]; 
                }
            }
            return _arg;
        }
        else if(this.state.type == RemotePasteDialog.TYPE_DATAGRID)
        {
            _arg = this.state.gridDataProvider.slice();
            if(this.props.remotearg && !this.props.remotearg.fields && this.props.remotearg.isDataWithHeader)
            {
                if(!_arg)_arg = [];
                var headerdata = {};
                for(let i = 0;i<this.state.gridColumns.length;i++)
                {
                    let gc = this.state.gridColumns[i];
                    headerdata[gc.key] = gc.name;
                }
                _arg.unshift(headerdata);
            }
            return _arg;
        }
        
        return $(textModeInput).val();
    }
    
    btnRequire0_clickHandler(event)
    {
        var _arg = $(this.textModeInput).val();
        this.dobtnRequire_clickHandler(event,_arg);
    }
    
    btnRequire1_clickHandler(event)
    {
        var remotearg = this.props.remotearg;
        var _arg = {};
        if(remotearg.fields && remotearg.fields.length>0)
        {
            for(let i = 0;i<this.state.keyValueGridRows.length;i++)
            {
                let item = this.tate.keyValueGridRows[i];
                _arg[item.serverfield] = item.value;
            }
        }
        else
        {
            var ac = this.state.keyValueGridRows;
            var column0 = this.state.keyValueColumns[0];
            var column1 = this.state.keyValueColumns[1];
            var key1 = column0.key;
            var key2 = column1.key;
            for(let i = 0;i<ac.length;i++)
            {
                let item = ac[i];
                _arg[item[key1]] = item[key2]; 
            }
        }
        
        this.dobtnRequire_clickHandler(event,_arg);
    }
    
    btnRequire_clickHandler(event)
    {
        var _arg = this.state.gridDataProvider.slice();
        var remotearg = this.props.remotearg;
        if(remotearg && !remotearg.fields && remotearg.isDataWithHeader)
        {
            if(!_arg)_arg = [];
            var headerdata = {};
            for(let i = 0;i<this.state.gridColumns.length;i++)
            {
                let gc = this.state.gridColumns[i];
                headerdata[gc.key] = gc.name;
            }
            _arg.unshift(headerdata,0);
            //_arg.addItemAt(headerdata,0);
        }
        this.dobtnRequire_clickHandler(event,_arg);
    }
    
    dobtnRequire_clickHandler(event,_arg)
    {
        var remotearg = this.props.remotearg;
        var group = this.getTaskGroup(this.props.task,window.formModuleInstance);
        var _methodName = "clipboardOK_" + remotearg.id;
        var mi = FormResourceUtil.getCommandArgMethodInfo(_methodName,window.menuItemId,window.formId);
        if(!mi)
            return;
        
        if(mi.prefetch==true)
        {
            if(mi.commandResult)
                CommandResolver.resolve(mi.commandResult.tasks, this);
            this.close();
        }
        else
        {	
            var arg = CommandResolver.getSendCmd(window.formModuleInstance, group!=null?group.groupAlias:"", mi);
            arg.argObject = _arg;
            var command = CommandHelper.createFormInstance(window.formModuleInstance.formName, _methodName, "CommandResult")
                .appendArg(arg, "CommandArg");
            var that = this;
            ServiceHelper.addTokenWithCommand({command:command,resultFunction:
                function(event)
                {
                    that.rpc_result_do_server(event,group);
                }});
        }
    }
    
    rpc_result_do_server(event,group)
    {
        this.close();
        CommandResolver.resolve(event.result.tasks, window.formModuleInstance, group);
    }

    //复制到剪贴板
    exportClipBoard(exportHeads,exportBodys)
    {
        if(!exportHeads || exportHeads.length == 0)
        {
            Fade.show({text:"没有可导出的列"});
            return;
        }
        
        var rowCount=exportBodys.length;
        var data="";
        var fieldSeparator="\t";
        var lineSeparator="\n";
        var fields=[];
        //循环表头数据
        for(var i=0;i<exportHeads.length;i++){
            var filed=exportHeads[i];
            fields.push(filed.headerText);
            data += (filed.headerText + fieldSeparator);
            if(i==exportHeads.length-1){
                data+=lineSeparator;
            }
        }

        //循环行数据
        for(var i=0;i<rowCount;i++){
            var record=exportBodys[i];
            for(var j=0;j<record.length;j++){
                var item=record[j];
                data+=item+fieldSeparator;
                if(j==record.length-1)
                    data+=lineSeparator;
            }
            
        }
        const copyHandler = (e) => {
            e.clipboardData.setData('text/plain', data);
            e.preventDefault();
        };
        document.addEventListener('copy', copyHandler);
        Copy(data);
        document.removeEventListener('copy', copyHandler);
        var options = {
            state: 'success',
            text: '成功复制到剪切板'
        }
        Fade.show(options);
    }
    
    
    grid1_copyHandler(event)
    {
        this.exportClipBoard(this.state.keyValueColumns,this.state.keyValueGridRows);	
    }
    		
    grid_copyHandler(event)
    {
        this.exportClipBoard(this.state.gridColumns,this.state.gridDataProvider);
    }

    rowClick = (index,record,proxy) =>{
        this.setState({ selectedIndexes:[index]});
    }

    onHeaderDragHandleDoubleClick(column)
    {
      let max = column.name.visualLength();
      //let fontSizeRequired = false;
      let rows = this.state.gridDataProvider?this.state.gridDataProvider:this.state.keyValueGridRows;
      for(let i = 0;i<rows.length;i++)
      {
        let item = rows[i];
        let value = item[column.key];
        if(value)
        {
          let width = value.visualLength();
          if(width>max)
            max = width;
        }
          
      }
      return max>0?max+20:0;
    }
    
    render()
    {
        let content;let buttonDsiplay = (this.state.mode == RemotePasteDialog.MODE_IN?'flex':'none');
        let _label;
        let cancellabel = this.props.remotearg.cancelLabel?this.props.remotearg.cancelLabel:"清空数据";
        let oklabel = this.props.remotearg.okLabel?this.props.remotearg.okLabel:"提交数据";
        if(this.state.type == RemotePasteDialog.TYPE_TEXT)
        {
            _label =this.state.mode == RemotePasteDialog.MODE_IN?RemotePasteDialog.MODE_IN_0_PROMPT:RemotePasteDialog.MODE_OUT_0_PROMPT
            if(this.props.remotearg.promptInfo){
                _label = this.props.remotearg.promptInfo;
            }
            content = 
                <div style={{display:'flex',flexDirection:'column',flexGrow:100,alignSelf:'strecth'}}>
                    <label>{_label}</label>
                    <div style={{display:'flex',flexDirection:'row',flexGrow:100,alignSelf:'strecth'}}>
                        <textarea style={{flexGrow:100}} ref={node=>this.textModeInput = node} rows='5' defaultValue = {this.state.mode0Text}></textarea>
                        <div style={{display:buttonDsiplay,flexDirection:'column',alignSelf:'strecth',marginLeft:'5px'}}>
                            <button type="button" className="btn btn-info" style={{height:'25px'}} onClick={this.btnclear0_clickHandler.bind(this)}>{cancellabel}</button>
                            <button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.btnRequire0_clickHandler.bind(this)}>{oklabel}</button>
                        </div>
                    </div>
                </div>;
        }
        else if(this.state.type == RemotePasteDialog.TYPE_KEYVALUE)
        {
            _label =this.state.mode == RemotePasteDialog.MODE_IN?RemotePasteDialog.MODE_IN_1_PROMPT:RemotePasteDialog.MODE_OUT_1_PROMPT
            if(this.props.remotearg.promptInfo){
                _label = this.props.remotearg.promptInfo;
            }
            content = 
                <div style={{display:'flex',flexDirection:'column',flexGrow:100,alignSelf:'strecth'}}>
                    <label>{_label}</label>
                    <div style={{display:'flex',flexDirection:'row',flexGrow:100,alignSelf:'strecth'}}>
                        <ReactDataGrid ref={ node => this.keyValueGrid = node } enableCellSelect={true} columns={this.state.keyValueColumns} rowGetter={this.getKeyValueGridRowAt.bind(this)} rowsCount={this.getSize.bind(this)} onGridRowsUpdated={this.handleGridRowsUpdated2}
                                       enableRowSelect={false} rowSelection={{showCheckbox: false,selectBy: {indexes: this.state.selectedIndexes}}} onRowClick={this.rowClick} rowHeight={30} minHeight={240} rowScrollTimeout={500}  cellNavigationMode="loopOverRow"
                                       onDoubleClickToFit={this.onHeaderDragHandleDoubleClick.bind(this)}/>
                        <div style={{display:buttonDsiplay,flexDirection:'column',flexGrow:100,alignSelf:'strecth',marginLeft:'5px'}}>
                            <button type="button" className="btn btn-info" style={{height:'25px'}} onClick={this.btnclear1_clickHandler.bind(this)}>{cancellabel}</button>
                            <button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.btnRequire1_clickHandler.bind(this)}>{oklabel}</button>
                            <button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.copyPasteClick.bind(this)}>{this.state.mode == RemotePasteDialog.MODE_IN?"粘贴数据":"复制数据"}</button>
                        </div>
                    </div>
                </div>;
        }
        else if(this.state.type == RemotePasteDialog.TYPE_DATAGRID)
        {
            _label =this.state.mode == RemotePasteDialog.MODE_IN?RemotePasteDialog.MODE_IN_2_PROMPT:RemotePasteDialog.MODE_OUT_2s_PROMPT
            if(this.props.remotearg.promptInfo){
                _label = this.props.remotearg.promptInfo;
            }
            content = 
                <div style={{display:'flex',flexDirection:'column',flexGrow:100,alignSelf:'strecth'}}>
                    <label>{_label}</label>
                    <div style={{display:'flex',flexDirection:'row',flexGrow:100,alignSelf:'strecth'}}>
                        <ReactDataGrid ref={ node => this.grid = node } enableCellSelect={true} columns={this.state.gridColumns} rowGetter={this.getGridRowAt} rowsCount={this.getGridSize()} onGridRowsUpdated={this.handleGridRowsUpdated}
                                       enableRowSelect={false} rowSelection={{showCheckbox: false,selectBy: {indexes: this.state.selectedIndexes}}} onRowClick={this.rowClick} rowHeight={30} minHeight={240} rowScrollTimeout={500}  cellNavigationMode="loopOverRow"
                                       onDoubleClickToFit={this.onHeaderDragHandleDoubleClick.bind(this)}/>
                        <div style={{display:buttonDsiplay,flexDirection:'column',flexGrow:100,alignSelf:'strecth',marginLeft:'5px'}}>
                            <button type="button" className="btn btn-info" style={{height:'25px'}} onClick={this.btnclear2_clickHandler.bind(this)}>{cancellabel}</button>
                            <button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.btnRequire_clickHandler.bind(this)}>{oklabel}</button>
                            <button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.copyPasteClick.bind(this)}>{this.state.mode == RemotePasteDialog.MODE_IN?"粘贴数据":"复制数据"}</button>
                        </div>
                    </div>
                </div>;
        }
        let _title = this.props.remotearg.title?this.props.remotearg.title:"剪贴面板";
        return <div ref={node=>this.remotePasteDialogContainer=node}  style={{position:'absolute',alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px",backgroundColor:'white',width:'450px',height:'330px',display:'flex',flexDirection:'column'	}}>
          <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative"}}>
            <i className="fa fa-close" style={{position: 'absolute',top: '13px', right: '10px', fontSize: '15px', cursor: 'pointer'}}  onClick={this.close.bind(this)}></i>
            <h5 className="modal-title" style={{fontWeight:'bolder'}}>{_title}</h5>
          </div>
          {content}
          <div className="modal" ref={node=>this.pasteHelperContainer=node} style={{zIndex: '2000',display:'none'}}>
            <div className="modal-dialog" style={{marginTop:'100px',width:'400px'}}>
                <div className="modal-content">
                  <div className="modal-header" style={{padding:'5px 15px'}} >
                    <i className="fa fa-close" style={{position:"absolute",top:"13px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closePaste.bind(this)}></i>
                    <span className="modal-title" style={{marginTop:'0',marginBottom:'0',fontSize:'16px'}} >数据粘贴</span>
                  </div>
                  <div className="modal-body" style={{display:'flex',flexDirection:'row',padding:'10px 5px'}} >
                    <textarea style={{width:'378px',height:'274px'}} ref={node => this.pasteTextContainer = node} placeholder="请将内容粘贴到此处然后点击确定"></textarea>
                  </div>
                  <div className="modal-footer" style={{padding:'5px 15px'}}>
                    <button type="button" className="btn btn-primary" onClick={this.btnPasteRequire.bind(this)}>确定</button>
                  </div>
                </div>
            </div>
          </div>
        </div>;
        
    }
}



// WEBPACK FOOTER //
// ./src/utils/RemotePasteDialog.js